<template>
  <div>
    <DialogYesNo
      :visible="visible"
      @hidden="hidden"
      size="lg"
      title="Ask a question:"
      @ok="submitQuestion"
    >
      <b-form-group
        description="A very short description of your question. Example: 'Joker'"
        label="The title:"
      >
        <b-form-input
          v-model="question.title"
          maxlength="15"
          autofocus
          required
        />
      </b-form-group>
      <b-form-group
        description="Put your question here. Each team can answer once."
        label="Your question:"
      >
        <b-form-input v-model="question.question" required />
      </b-form-group>
      <b-form-group description label="Select an answer type:">
        <b-form-radio v-model="question.type" name="some-radios" value="any">
          Anything
          <span class="text-muted">[arbitrary text]</span>
        </b-form-radio>
        <b-form-radio v-model="question.type" name="some-radios" value="number">
          Number
          <span class="text-muted">[only digits]</span>
        </b-form-radio>
        <b-form-radio v-model="question.type" name="some-radios" value="round">
          Round name
          <span class="text-muted">[name of a quiz round]</span>
        </b-form-radio>
      </b-form-group>
      <b-form-group
        description="Questions can be answered while they are enabled. You can allow/deny answers at any time."
      >
        <b-form-checkbox
          v-model="question.active"
          name="checkbox-1"
          :value="1"
          :unchecked-value="0"
          >Enable answers right now</b-form-checkbox
        >
      </b-form-group>
      <b-form-group
        description="If checked, the team's answers will be shown directly in the score table. If you expect long answers, maybe disable this one."
      >
        <b-form-checkbox
          v-model="question.showInTable"
          name="checkbox-1"
          :value="1"
          :unchecked-value="0"
          >Show in score table</b-form-checkbox
        >
      </b-form-group>
      <b-form-group
        description="If you check this, anyone can see the answers, even spectators."
      >
        <b-form-checkbox
          v-model="question.public"
          name="checkbox-1"
          :value="1"
          :unchecked-value="0"
          >Public answers</b-form-checkbox
        >
      </b-form-group>
    </DialogYesNo>
    <DialogError v-model="errorVisible">{{ errorMessage }}</DialogError>
  </div>
</template>

<script>
import DialogError from "@/components/DialogError";
import DialogYesNo from "@/components/DialogYesNo";
export default {
  name: "HostQuestionDialog",
  components: { DialogYesNo, DialogError },
  props: {
    quizID: {
      default: 0
    },
    visible: {
      default: false
    }
  },
  model: {
    prop: "visible",
    event: "updateVmodel"
  },
  data() {
    return {
      question: this.emptyQuestion(),
      errorVisible: false,
      errorMessage: ""
    };
  },
  methods: {
    emptyQuestion() {
      return {
        quiz_id: this.quizID,
        title: "",
        question: "",
        type: "any",
        active: 1,
        public: 0,
        showInTable: 1
      };
    },
    hidden() {
      this.$emit("updateVmodel", false);
    },
    submitQuestion(ev) {
      if (this.question.question.length == 0) {
        ev.preventDefault();
        this.errorMessage = "You did not ask a question.";
        this.errorVisible = true;
        return;
      }

      if (this.question.title.length == 0) {
        ev.preventDefault();
        this.errorMessage = "You did not set a title.";
        this.errorVisible = true;
        return;
      }

      this.$emit("question-submit", this.question);
    }
  }
};
</script>
